import Cookies from 'universal-cookie';
import { useState, useEffect } from 'react';
import env from './env';

// Wrap universal-cookies get/set with env specific domain information
const jar = {
  cookies() {
    return new Cookies();
  },
  get(key) {
    return this.cookies().get(key);
  },
  set(key, value) {
    const domain = env().allDomains;
    this.cookies().set(key, value, { path: '/', domain });
  },
  remove(key) {
    return this.cookies().remove(key);
  }
};

// Call with a Class to add getters/setters using cookie storage
// Ex: withCookieJar(MyClass, 'aCookieBasedProp', 'anotherOne');
const withCookieJar = (obj, ...args) => {
  [...args].forEach(prop => {
    Object.defineProperty(obj.prototype, prop, {
      set: val => jar.set(prop, val),
      get: () => jar.get(prop)
    });
  });
  return obj;
};

// Custom hook for React components
const useCookieJar = (key, defaultValue) => {
  // Always default to existing cookie val
  let cookieVal = jar.get(key);

  // Safe guard against 'undefined' string values
  cookieVal = cookieVal === 'undefined' ? undefined : cookieVal;

  // set default if available
  cookieVal = cookieVal || defaultValue;

  // Get/Set in memory in addition to in cookie so we can rerender components as needed
  const [value, setValue] = useState(cookieVal);

  // Update cookie when state changes
  useEffect(() => jar.set(key, value), [value, key]);

  // Return just like useState but with remove function
  return [value, setValue, () => jar.remove(key)];
};

export default jar;
export { withCookieJar, useCookieJar };



// WEBPACK FOOTER //
// ./app/javascript/app/utils/cookie_jar.js